<template>
  <div :style="{ backgroundImage: 'url(' + bgImage + ')' }" id="div-bg">
    <v-card class="mx-auto" width="700px" style="border-radius: 13px" elevation="20">
      <v-row no-gutters>
        <v-col>
          <v-img class="fs-logotipo-login" :src="logo"/>
          <v-form class="ma-5 px-3">
            <span style="font-size: 14px; font-weight: 300; letter-spacing: .5px">Esqueceu sua Senha?</span>
            <v-text-field
              class="mt-8"
              type="text"
              v-model="email"
              label="E-mail"
              placeholder=" "
              style="font-size: 13px"
              autofocus
              spellcheck="false"
              outlined
              dense
            />
            <v-btn block @click="formSubmit()" :disabled="btnDisabled" color="primary">
              <v-icon small class="mr-2">
                mdi-key-variant
              </v-icon>
              {{ btnText }}
            </v-btn>
            <div class="mt-7 mb-10 text-center">
              <router-link to="signIn" tag="a" class="text-muted ">
                <u>Voltar para o Login</u>
              </router-link>
            </div>
          </v-form>
        </v-col>
        <v-col>
          <div id="div-card-image" :style="{ backgroundImage: 'url(' + formImage + ')' }">
            <v-btn outlined @click="$router.push('signIn')" color="primary">
              <v-icon small class="mr-2">mdi-email-outline</v-icon>
              Entrar com email
            </v-btn>
          </div>
        </v-col>
      </v-row>
    </v-card>
  </div>
</template>
<script>
import { mapMutations } from 'vuex'
import { add } from '@/api/crud'

export default {
  metaInfo: {
    title: 'Forgot Password'
  },
  data () {
    return {
      email: '',
      btnDisabled: false,
      btnText: 'Resetar Senha',
      bgImage: require('@/assets/images/photo-wide-4.jpg'),
      logo: require('@/assets/images/logo.png'),
      formImage: require('@/assets/images/forgot-password.jpg')
    }
  },
  methods: {
    ...mapMutations('global', ['setSnackbar']),
    async formSubmit () {
      if (this.email.length > 0) {
        this.btnDisabled = true
        const res = await add('/emails/forgot-password', null, { email: this.email })
        this.setSnackbar({ msg: res.msg, color: 'warning' })
        // setTimeout(() => {
        //   this.$router.push('/app/sessions/signIn')
        // }, 3000)
        this.btnDisabled = false
      } else {
        this.setSnackbar({ msg: 'Informe um e-mail válido!', color: 'error' })
      }
    }
  }
}
</script>

<style scoped>
  #div-bg {
    align-items: center;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
    height: 100vh;
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
    background-size: cover;
  }
  #div-card-image {
    padding-top: 310px;
    text-align: center;
    width: 350px;
    height: 100%;
    border-top-right-radius: 13px;
    border-bottom-right-radius: 13px;
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
    background-size: cover;
  }
  .fs-logotipo-login {
    width: 100px !important;
    margin-top: 30px;
    margin-left: 115px;
  }
  .fs-device-desc {
    text-align:center;
    margin-top: 80px;
    margin-bottom: -10px;
    font-size: 10px;
    padding-left: 5px;
    padding-right: 5px;
    font-weight: 300;
    letter-spacing: .4px;
    color: black;
  }
</style>
